<template>
    <v-card
        class="mx-auto card-balance"
        :class="{ 'go-green': goGreen }"
        outlined
    >
        <v-card-text class="card-balance-text-group go-green d-none d-md-flex">
            <span class="card-balance-title">
                Your Current Balance
            </span>
        </v-card-text>
        <v-card-text class="card-balance-currency d-none d-md-block">
            {{ currency }}
        </v-card-text>
        <v-card-text
            class="card-current-balance-group align-center"
            :class="{
                'medium-size': formattedLength > 6 && formattedLength < 8,
                'small-size': formattedLength >= 8,
            }"
        >
            <span class="card-balance-currency d-md-none">
                {{ currency }}
            </span>
            <span class="d-none d-md-inline card-current-currency">
                {{ formattedCurrency }}
            </span>
            <span class="d-none d-md-inline card-amount card-current-balance">
                {{ formattedAmount }}
            </span>
            <span class="d-inline d-md-none card-current-balance">
                {{ formattedBalance }}
            </span>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'display-amount',
    props: {
        amount: {
            type: Number,
            required: true,
        },
        currency: {
            type: String,
            required: true,
        },
        goGreen: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        formattedBalance() {
            return this.amount.toLocaleString(undefined, {
                style: 'currency',
                currency: this.currency,
            });
        },
        formattedCurrency() {
            return this.formattedBalance.substring(
                0,
                this.currencyAmountSplitIndex
            );
        },
        formattedAmount() {
            return this.formattedBalance.substring(
                this.currencyAmountSplitIndex
            );
        },
        currencyAmountSplitIndex() {
            return this.formattedBalance.search(/\d/);
        },
        formattedLength() {
            return (
                this.formattedCurrency.length / 3 + this.formattedAmount.length
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.card-balance {
    width: 260px;
    height: 75px;
    @include break('sm') {
        width: 440px;
    }
    @include break('md') {
        width: 308px;
        height: 190px;
        min-width: 308px;
    }
    border-radius: 6px;
    border: solid 1px rgba(75, 75, 75, 0.69);
    // border: solid 1px rgba(151, 151, 151, 0.39);
    // border style
    // border: 1px solid;
    // border-image-slice: 1;
    // border-image-source: linear-gradient(
    //     to top,
    //     rgba(255, 29, 193, 0),
    //     rgba(219, 102, 200, 0.57) 63%
    // );
    @include break('md') {
        &.go-green {
            background-image: radial-gradient(
                circle at 50% 0,
                rgba(109, 210, 77, 0.3),
                rgba(0, 0, 0, 0)
            );
            .card-balance-text-group {
                background-image: linear-gradient(
                    to right,
                    rgba(89, 170, 94, 0.32),
                    rgba(180, 241, 126, 0.59) 21%,
                    rgba(151, 234, 104, 0.6) 52%,
                    rgba(180, 241, 126, 0.39) 84%,
                    rgba(89, 170, 94, 0.36)
                );
            }
        }
    }

    .card-balance-text-group {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 32px;
        max-height: 32px;
        text-align: center;
        border-radius: 6px;
        background-image: linear-gradient(
            to right,
            rgba(210, 38, 213, 0),
            #5776cf 21%,
            #2960e8 52%,
            #5776cf 84%,
            rgba(208, 44, 218, 0)
        );
        .card-balance-title {
            color: #ffffff;
            font-size: 14px;
            line-height: normal;
            font-weight: 500;
            vertical-align: baseline;
        }
        .card-balance-text {
            color: #212843;
            font-size: 11px;
            line-height: 0.8;
        }
    }
    .card-balance-currency {
        font-size: 16px;
        font-weight: normal;
        vertical-align: super;
        @include break('md') {
            font-size: 18px;
            font-weight: bold;
            vertical-align: baseline;
        }

        line-height: normal;
        padding-bottom: 8px;
        color: #212843;
    }
    .card-current-balance-group {
        color: #212843;
        padding: 12px 16px 0 16px;
        @include break('md') {
            padding-top: 0;
        }
        line-height: normal;
        .card-current-currency {
            font-size: 40px;
            @include break('md') {
                font-size: 30px;
                vertical-align: top;
            }
        }
        .card-current-balance {
            font-size: 40px;
            line-height: 1.25;
            @include break('md') {
                font-size: 80px;
                line-height: 1;
            }
        }
        &.medium-size {
            @include break('md') {
                .card-amount {
                    font-size: 64px;
                    line-height: 1.5;
                }
                .card-current-currency {
                    font-size: 24px;
                    vertical-align: 1.5em;
                }
            }
        }
        &.small-size {
            @include break('md') {
                .card-amount {
                    font-size: 52px;
                    line-height: 1.8;
                }
                .card-current-currency {
                    font-size: 20px;
                    vertical-align: 1.5em;
                }
            }
        }
    }
}
</style>
